'use client';
import { useTranslations } from 'next-intl';
import { useContext } from 'react';
import { useWatch } from 'react-hook-form';

import { useSelectedCurrency } from '@/shared/lib/hooks/useSelectedCurrency';
import { Icon } from '@/shared/ui/icon';

import './product-detail.scss';
import { useCartStore, getPriceValueTranslation } from '@/entities/cart';
import { ProductDetailContext } from './provider';

export const ProductDetailInfoPackaging = () => {
    const t = useTranslations();
    const [selectedCurrency] = useSelectedCurrency();
    const { formMethods } = useContext(ProductDetailContext);
    const getItemPrices = useCartStore((s) => s.getItemPrices);
    const selectedVariant = useWatch({ control: formMethods.control, name: 'variant' });

    const priceData = selectedVariant ? getItemPrices(selectedVariant) : null;

    const packagingPrice = (priceData?.packagePrices ?? []).reduce(
        (sum, pkg) => sum + parseFloat(pkg.priceValue.amount),
        0,
    );

    if (!packagingPrice) {
        return null;
    }

    return (
        <div className="product-detail__info-packaging" data-testid="product-detail-packaging">
            <Icon name="package" width={24} height={24} />
            <span
                data-testid="product-detail-packaging-price"
                data-amount={packagingPrice}
                data-currency={selectedCurrency}
            >
                {t('WORDS.PACKAGE', {
                    count: getPriceValueTranslation({
                        amount: packagingPrice,
                        currency: selectedCurrency,
                        t,
                    }),
                })}
            </span>
        </div>
    );
};
